/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DokanOverviewCard from "../../../components/card/DokanOverviewCard";
import { fetchSalesOverview } from "../../../redux/reports/reportsActions";

const Overview = () => {
  // fetch data from Redux store.
  const vendorSalesOverview = useSelector(
    (state) => state.reports.salesOverview
  );

  const loading = useSelector(
    (state) => state.reports.loading
  );

  const dispatch = useDispatch();
// console.log(parse(vendorSalesOverview?.balance).props.children.props.children);
  useEffect(() => {
    dispatch(fetchSalesOverview());
  }, [dispatch]);

  return (
    <>
    <div className="grid grid-cols-1 md:grid-cols-2 md:gap-2 grid-flow-row row-gap-4 lg:grid-flow-col lg:col-gap-5">
      <div>
      <DokanOverviewCard
          icon="#totalSales"
          title="Total Sales"
          isCurrency
          value={vendorSalesOverview?.balance || "0"}
          loading={loading}
        />
      </div>
      <div>
      <DokanOverviewCard
          icon="#totalEarnings"
          title="Total Earnings"
          isCurrency
          value={vendorSalesOverview?.earnings || "0"}
          loading={loading}

        />
      </div>
      <div>
      <DokanOverviewCard
          icon="#totalOrders"
          title="Total Orders"
          value={vendorSalesOverview?.orders?.total || "0"}
          loading={loading}

        />
      </div>
      <div>
      <DokanOverviewCard
          icon="#totalProducts"
          title="Total Product"
          value={vendorSalesOverview?.products?.total || "0"}
          loading={loading}

        />
      </div>
    </div>
    </>
  );
};

export default Overview;
